// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__k1MVk","colCheckbox":"styles_colCheckbox__20FS3"};